// removed by extract-text-webpack-plugin
module.exports = {"right":"SimplDatepicker__right___3YopM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SimplDatepicker/SimplDatepicker.scss
// module id = 1196
// module chunks = 1